var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF8787"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20.5996C25.3832 20.5996 20 25.4444 20 31.3996C20 33.4812 20.6584 35.4976 21.9072 37.2412C21.6708 39.856 21.0372 41.7972 20.1172 42.7168C19.9956 42.8384 19.9652 43.0244 20.042 43.178C20.11 43.3152 20.25 43.3996 20.4 43.3996C20.4184 43.3996 20.4368 43.3984 20.4556 43.3956C20.6176 43.3728 24.3808 42.8312 27.1028 41.26C28.6484 41.8836 30.2948 42.1996 32 42.1996C38.6168 42.1996 44 37.3548 44 31.3996C44 25.4444 38.6168 20.5996 32 20.5996ZM26.4 32.9996C25.5176 32.9996 24.8 32.282 24.8 31.3996C24.8 30.5172 25.5176 29.7996 26.4 29.7996C27.2824 29.7996 28 30.5172 28 31.3996C28 32.282 27.2824 32.9996 26.4 32.9996ZM32 32.9996C31.1176 32.9996 30.4 32.282 30.4 31.3996C30.4 30.5172 31.1176 29.7996 32 29.7996C32.8824 29.7996 33.6 30.5172 33.6 31.3996C33.6 32.282 32.8824 32.9996 32 32.9996ZM37.6 32.9996C36.7176 32.9996 36 32.282 36 31.3996C36 30.5172 36.7176 29.7996 37.6 29.7996C38.4824 29.7996 39.2 30.5172 39.2 31.3996C39.2 32.282 38.4824 32.9996 37.6 32.9996Z",
    fill: "#D31C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_1482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.8fa85173e619f42e8f5da5344265a958.svg";
export { ForwardRef as ReactComponent };